import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='Ryan Hill'
        dateTime='2021-12-19'
        tag='Memo'
        title='$8/mo for small sellers & Removing weekly billing'
      >
        <p>
          <b>Update:</b> The Small Seller program is no longer available. Learn more{' '}
          <a href='https://tools.oneshop.com/company/memos/2022-03-02-ending-small-seller-program'>here.</a>
        </p>
        <p>
          Hi everyone, I’m Ryan and I oversee our Premium offering here at OneShop. I’m following up on{' '}
          <a href='https://tools.oneshop.com/company/memos/2021-12-13-affordability-changes'>
            this week’s earlier update
          </a>{' '}
          about the Affordability Program. I’m also sharing that we will be removing weekly pricing as an option for new
          subscriptions. Please read the full details below.
        </p>

        <h4>New price for small sellers</h4>
        <p>Small sellers will pay $8/mo every month they sell less than $80/mo in goods.</p>

        <p>You’re considered a small seller if you’ve sold less than $1,500 in the past year and $3,000 all-time.</p>

        <p>
          As always, we reserve the right to deny special pricing for sellers that we suspect are abusing the spirit of
          the program.
        </p>

        <p>
          {' '}
          Since part of our team will be gone during the week of Christmas, this will be available on December 27th.
          Thanks for being so patient with revisions to the program.{' '}
        </p>

        <h4>Removing weekly billing</h4>
        <p>
          We will remove the weekly billing by the end of December. We originally added it to lower the upfront
          commitment for people new to reselling.
        </p>

        <p>
          If you are paying weekly today, you can keep your plan for the next 6 months. On June 19, 2022 if you are
          still subscribed you will be automatically upgraded to the $45/mo plan. If you switched today you’d save $16
          over the next 6 months.
        </p>

        <p>If you cancel we may not honor renewing your access to the weekly plan.</p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
